<template>
  <div class="share-wrapper">
    <img class="icon" src="@/assets/img/share/confirm/order.png" alt="" v-if="info.type === 'order'">
    <img class="icon" src="@/assets/img/share/confirm/customer.png" alt="" v-else>
    <div class="title">{{info.title}}</div>
    <div class="tip">{{info.tip}}，如需更多信息可前往擎科官网进行查看</div>
    <div class="share-btn" @click="() => $router.replace('/')">擎科官网</div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmPopup',
  data() {
    return {
      info: {}
    }
  },
  created() {
    const { type } = this.$route.query
    if (type === 'order') {
      this.info = {
        type,
        tip: '您的订单已提交成功',
        title: '订单提交成功！'
      }
    } else {
      this.info = {
        type,
        tip: '您已成功为课题组成员授权成功',
        title: '授权成功！'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.share-wrapper {
  height: 100vh;
  background: linear-gradient(180deg, rgba(0, 64, 151, 0.05) 0%, rgba(0, 64, 151, 0.01) 100%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .title {
    font-size: 40px;
    font-weight: 600;
    color: #323232;
    margin-top: 5vh;
  }
  .tip {
    font-size: 18px;
    color: #4c4c4c;
    margin-top: 2vh;
  }
  .share-btn {
    margin-top: 10vh;
    height: 7.4vh;
    line-height: 7.4vh;
    width: 25vw;
    background-color: #1e4998;
    border-radius: 3.7vh;
    font-size: 24px;
    font-weight: 600;
    color: #fff;
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/share/confirm-popup/index.vue